import { useEffect, useState } from 'react'
import { api, type Features } from './api'

let cached: Promise<Features> | null = null

/** Server features, fetched once per page load. */
export function useFeatures(): Features | null {
  const [features, setFeatures] = useState<Features | null>(null)
  useEffect(() => {
    cached ??= api.features().catch(() => ({ catalog: false, providers: [] }))
    let cancelled = false
    void cached.then((f) => !cancelled && setFeatures(f))
    return () => {
      cancelled = true
    }
  }, [])
  return features
}
